import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { OrderContext } from '../../ContextApi/context';
import OrderFunctions from '../../OrderSettings/OrderFunctions';
import { isMobileDevice, isNativeApp } from '../../myFunctions';


// מוצג רק בגלישה ממכשיר מובייל שאיננו האפליקציה עצמה (לא דסקטופ, לא WebView של האפליקציה)
const AppDownloadPromo = (props) => {
    const [order, setOrder] = useContext(OrderContext);
    const history = useHistory();

    if (!isMobileDevice() || isNativeApp()) {
        return null;
    }

    const goToAPPS = () => {
        setOrder(OrderFunctions.clearOrd());

        // חלון התודה עשוי לרוץ בתוך iframe (חזרה מקארדקום) - אז מנווטים את חלון האב
        if (window.parent !== window) {
            window.parent.location.href = '/apps';
        }
        else {
            history.push("/apps");
        }
    }

    return (
        <div className={"appPromoBlock"}>
            <span className={"appPromoTxt"}>יותר כיף דרך האפליקציה</span>
            <button type="button" className={"appPromoBtn pointing"} onClick={goToAPPS}>
                הורד את האפליקציה
            </button>
        </div>
    )
}

export default AppDownloadPromo;
